import { Outlet } from 'react-router-dom'
import { AppLayoutWithActivateGuard } from '@components/AppLayout/AppLayout'
import CreateGridBotPage from '@features/bot/pages/CreateGridBotPage/CreateGridBotPage'
import CreateBotPage from '@features/bot/pages/CreateBotPage/CreateBotPage'
import { contractPath, ContractRoutesPath } from '@config/Router'
import ManageStrategy from '@features/bot/pages/ManageStrategy/ManageStrategy'
import BotDashboardPage from '@features/bot/pages/BotDashboardPage/BotDashboardPage'
import CreateBotMenuPage from '@features/bot/pages/CreateBotMenuPage/CreateBotMenuPage'
import { BotTypeContextProvider } from '@features/bot/components/BotTypeContext/BotTypeContext'
import { BotMarketType } from '@interfaces/BotMarketEnum'

import CreateEasyBotPage from '@features/bot/pages/CreateEasyBotPage/CreateEasyBotPage'
import CreateEasyTradeOwnerSelectPage from '@features/bot/pages/CreateEasyTradeOwnerSelectPage/CreateEasyTradeOwnerSelectPage'
import BotPage from './pages/BotPage/BotPage'
import BotLayout from './components/BotLayout/BotLayout'

export const ContractRoutes = {
  path: contractPath,
  element: <Outlet />,
  children: [
    {
      path: ContractRoutesPath.dashboard.path,
      element: (
        <AppLayoutWithActivateGuard>
          <BotTypeContextProvider botMarketType={BotMarketType.FUTURE}>
            <BotDashboardPage key='BOT_DASHBOARD_FUTURE' />
          </BotTypeContextProvider>
        </AppLayoutWithActivateGuard>
      ),
    },
    {
      path: ContractRoutesPath.createContractMenu.path,
      element: (
        <AppLayoutWithActivateGuard title='Create'>
          <BotTypeContextProvider botMarketType={BotMarketType.FUTURE}>
            <CreateBotMenuPage />
          </BotTypeContextProvider>
        </AppLayoutWithActivateGuard>
      ),
    },
    {
      path: ContractRoutesPath.createBot.path,
      element: (
        <AppLayoutWithActivateGuard title='Create bot'>
          <BotTypeContextProvider botMarketType={BotMarketType.FUTURE}>
            <CreateBotPage mode='bot' />
          </BotTypeContextProvider>
        </AppLayoutWithActivateGuard>
      ),
    },
    {
      path: ContractRoutesPath.createGridBot.path,
      element: (
        <AppLayoutWithActivateGuard>
          <BotTypeContextProvider botMarketType={BotMarketType.FUTURE}>
            <CreateGridBotPage mode='bot' />
          </BotTypeContextProvider>
        </AppLayoutWithActivateGuard>
      ),
    },
    {
      path: ContractRoutesPath.bot.path,
      element: (
        <BotLayout title='Bot detail'>
          <BotTypeContextProvider botMarketType={BotMarketType.FUTURE}>
            <BotPage />
          </BotTypeContextProvider>
        </BotLayout>
      ),
    },
    {
      path: ContractRoutesPath.createStrategy.path,
      element: (
        <AppLayoutWithActivateGuard title='Create strategy'>
          <BotTypeContextProvider botMarketType={BotMarketType.FUTURE}>
            <CreateBotPage mode='strategie' />
          </BotTypeContextProvider>
        </AppLayoutWithActivateGuard>
      ),
    },
    {
      path: ContractRoutesPath.updateCurrentBot.path,
      element: (
        <AppLayoutWithActivateGuard title='Edit bot'>
          <BotTypeContextProvider botMarketType={BotMarketType.FUTURE}>
            <CreateBotPage mode='bot-update-current-strategy' />
          </BotTypeContextProvider>
        </AppLayoutWithActivateGuard>
      ),
    },
    {
      path: ContractRoutesPath.updateMainBot.path,
      element: (
        <AppLayoutWithActivateGuard title='Edit bot'>
          <BotTypeContextProvider botMarketType={BotMarketType.FUTURE}>
            <CreateBotPage mode='bot-update-main-strategy' />
          </BotTypeContextProvider>
        </AppLayoutWithActivateGuard>
      ),
    },
    {
      path: ContractRoutesPath.updateAllBot.path,
      element: (
        <AppLayoutWithActivateGuard title='Edit bot'>
          <BotTypeContextProvider botMarketType={BotMarketType.FUTURE}>
            <CreateBotPage mode='bot-update-all-strategy' />
          </BotTypeContextProvider>
        </AppLayoutWithActivateGuard>
      ),
    },
    {
      path: ContractRoutesPath.copyByBot.path,
      element: (
        <AppLayoutWithActivateGuard>
          <BotTypeContextProvider botMarketType={BotMarketType.FUTURE}>
            <CreateBotPage mode='copy-by' />
          </BotTypeContextProvider>
        </AppLayoutWithActivateGuard>
      ),
    },
    {
      path: ContractRoutesPath.copyBySymbol.path,
      element: (
        <AppLayoutWithActivateGuard title='Create bot (Copy symbol)'>
          <BotTypeContextProvider botMarketType={BotMarketType.FUTURE}>
            <CreateBotPage mode='copy-by-symbol' />
          </BotTypeContextProvider>
        </AppLayoutWithActivateGuard>
      ),
    },
    {
      path: ContractRoutesPath.copyByPersonal.path,
      element: (
        <AppLayoutWithActivateGuard title='Create bot (Copy personal)'>
          <BotTypeContextProvider botMarketType={BotMarketType.FUTURE}>
            <CreateBotPage mode='copy-by-personal' />
          </BotTypeContextProvider>
        </AppLayoutWithActivateGuard>
      ),
    },
    {
      path: ContractRoutesPath.manageStrategy.path,
      element: (
        <AppLayoutWithActivateGuard title='Manage strategy'>
          <BotTypeContextProvider botMarketType={BotMarketType.FUTURE}>
            <ManageStrategy />
          </BotTypeContextProvider>
        </AppLayoutWithActivateGuard>
      ),
    },
    {
      path: ContractRoutesPath.updateStrategy.path,
      element: (
        <AppLayoutWithActivateGuard title='Edit strategy'>
          <BotTypeContextProvider botMarketType={BotMarketType.FUTURE}>
            <CreateBotPage mode='strategy-update' />
          </BotTypeContextProvider>
        </AppLayoutWithActivateGuard>
      ),
    },
    {
      path: ContractRoutesPath.createEasyTradeOwnerSelect.path,
      element: (
        <AppLayoutWithActivateGuard title='Easy trade'>
          <BotTypeContextProvider botMarketType={BotMarketType.FUTURE}>
            <CreateEasyTradeOwnerSelectPage />
          </BotTypeContextProvider>
        </AppLayoutWithActivateGuard>
      ),
    },
    {
      path: ContractRoutesPath.createEasyTradeConfig.path,
      element: (
        <AppLayoutWithActivateGuard title='Easy trade'>
          <BotTypeContextProvider botMarketType={BotMarketType.FUTURE}>
            <CreateEasyBotPage />
          </BotTypeContextProvider>
        </AppLayoutWithActivateGuard>
      ),
    },
  ],
}
